export default {"src":"/_next/static/media/discord.0edc95e1.svg","height":92,"width":92,"blurWidth":0,"blurHeight":0};